import { createSelector } from "reselect";

import { RootState } from "../modules";

export const linkReportsSelector = (state: RootState) =>
  state.linkReport.linkReports;
